import React from 'react';

const CarouselContext = React.createContext([]);

export const CarouselProvider = CarouselContext.Provider;
export default CarouselContext;